module.exports = __webpack_public_path__ + "img/default_user.64a211b3.png";